export default function CtaSection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20of%20fashion%20and%20lifestyle%20products%20silhouettes%20floating%20on%20warm%20gradient%20background%20from%20cream%20to%20soft%20terracotta%2C%20dreamy%20soft%20focus%20lighting%2C%20warm%20earthy%20tones%2C%20modern%20editorial%20art%20style%2C%20clean%20elegant%20composition%2C%20sophisticated%20minimal%20aesthetic%20with%20ethereal%20atmosphere&width=1800&height=800&seq=hb-cta-v2-finale&orientation=landscape"
          alt="Hoobuy Spreadsheet - Comece Agora"
          title="Comece a usar o Hoobuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/75 via-foreground-950/50 to-foreground-950/30"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-lg">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 leading-tight">
              Comece a usar o
              <br />
              Hoobuy Spreadsheet agora
            </h2>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed">
              Não perca mais tempo procurando produtos caros. Acesse o Hoobuy
              Spreadsheet agora mesmo e descubra os melhores preços direto da China.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center justify-center gap-2 px-8 py-3.5 text-sm font-semibold text-foreground-900 bg-background-50 hover:bg-background-100 rounded-full transition-all cursor-pointer whitespace-nowrap"
            >
              Acessar Spreadsheet
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 text-sm font-semibold text-background-50 border border-background-50/30 hover:bg-background-50/10 rounded-full transition-all cursor-pointer whitespace-nowrap"
            >
              Ir para Site Principal
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}